// Above this, pdf.js is told to fetch only the pages actually read instead of pulling the rest
// of the file down in the background. Below it the whole-file download is worth keeping, because
// it makes a jump to a distant page instant. Ten megabytes splits this library cleanly: its two
// heaviest documents are 34MB and 14MB, and everything else is under three.
const AUTO_FETCH_MAX_BYTES = 10 * 1024 * 1024

// What to hand `pdfjsLib.getDocument()`. Opening by URL rather than reading the file into an
// ArrayBuffer first is what lets the first page paint before the whole document has arrived;
// past the threshold it also stops the rest from arriving at all until it is read.
//
// Range requests need the storage service to send `Content-Length` and to expose `Accept-Ranges`
// and `Content-Range` to cross-origin scripts — pdf.js reads all three before it will ask for a
// range. The bucket does both; Rails' own Active Storage proxy cannot, because
// `ActiveStorage::Streaming` includes `ActionController::Live`, which deletes `Content-Length` on
// its first write. That is why these files are served straight from storage.
//
// `byteSize` of zero (an unknown size) keeps the whole-file behaviour.
export function pdfDocumentSource(url, byteSize) {
  // Both flags or neither: pdf.js honours `disableAutoFetch` only when streaming is off as well,
  // because a streaming read consumes the whole body regardless.
  const fetchOnlyPagesRead = byteSize > AUTO_FETCH_MAX_BYTES

  return { url: url, disableAutoFetch: fetchOnlyPagesRead, disableStream: fetchOnlyPagesRead }
}
